module.exports = __webpack_public_path__ + "static/elan-dark-ab6c9b7c4b48bf691056ee62e35a766c.png";